// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__vInsn","title":"Projects_title__w-qAZ","projects":"Projects_projects__O8KIQ"};